import routes from "pages/routes";
import React from "react";
import { Navigate, Routes as ReactRoutes, Route, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "store/AuthProvider";

const Routes = () => {
	const { isAuth } = useAuth();
	return (
		<ReactRoutes>
			{routes.map((route) => {
				let result: JSX.Element = route.renderer();
				switch (route.type) {
					case "auth":
						result = !isAuth ? (
							<Navigate
								replace
								to="/sign-in"
							/>
						) : (
							route.renderer()
						);
						break;
					case "unauth":
						result = isAuth ? (
							<Navigate
								replace
								to="/"
							/>
						) : (
							route.renderer()
						);
						break;
				}
				return (
					<Route
						key={route.path}
						path={route.path}
						element={result}
					/>
				);
			})}
			<Route
				path="*"
				element={
					<Navigate
						replace
						to="/"
					/>
				}
			/>
		</ReactRoutes>
	);
};

export default Routes;
